import styled from "@emotion/styled";
import { Button } from "@mui/material";

const ApplicationButton = styled(Button)(({ theme }) => {
    const isDarkMode = theme.palette?.mode === 'dark';
    
    return {
        borderRadius: 16,
        boxShadow: isDarkMode 
            ? '0 3px 15px 2px rgba(33, 150, 243, .5)' 
            : '0 3px 15px 2px rgba(33, 150, 243, .3)',
        height: 48,
        padding: '0 30px',
        fontSize: '1rem',
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all 0.3s ease',
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            boxShadow: isDarkMode 
                ? '0 6px 20px 2px rgba(33, 150, 243, .6)' 
                : '0 6px 20px 2px rgba(33, 150, 243, .4)',
            transform: 'translateY(-2px)',
            background: isDarkMode 
                ? theme.palette.primary.light 
                : theme.palette.primary.main,
            filter: isDarkMode ? 'none' : 'brightness(1.05)'
        },
        '&:disabled': {
            background: isDarkMode ? '#555' : '#ccc',
            color: isDarkMode ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)',
            boxShadow: 'none',
        }
    };
});

export default ApplicationButton;
